import { render, staticRenderFns } from "./TicketOrden.vue?vue&type=template&id=21720244"
import script from "./TicketOrden.vue?vue&type=script&lang=js"
export * from "./TicketOrden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports